import React from "react";
import { GetServerSidePropsContext } from "next";
import { SignupMain } from "containers/signup";
import { Meta } from "seo/meta";

function SignUpPage({ form_step, apiKey }) {
   console.log(form_step);
   return (
      <div>
         <Meta
            title="Metricks Signup"
            description="Metricks is the best affiliate marketing program tracking software. It allows you to easily create, track and manage your affiliate program"
         >
            <SignupMain apiKey={apiKey} />
         </Meta>
      </div>
   );
}

export default SignUpPage;

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
   const query = ctx.query;
   return !query
      ? {
           props: {
              apiKey: null,
           },
        }
      : {
           props: {
              apiKey: query?.apiKey ?? null,
           },
        };
};
